<div class="panel" [ngClass]="{ 'inline_hint-button': !!hintContent && paddings === 'none' }">
  <ion-icon 
    name="information-circle-outline" 
    size="large"
    *ngIf="hintContent"
    class="hint-button"
    (click)="openHint()"
  ></ion-icon>
  <div class="content">
    <ng-content></ng-content>
  </div>
  <div class="blocker" *ngIf="disabled"></div>
</div>

<popup-modal
  *ngIf="hintContent"
  [openModal]="openModalWithHint"
  (onClose)="closeHint()"
>
  <ng-container *ngTemplateOutlet="hintContent"></ng-container>
</popup-modal>